import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { idrataLinguaDalCloud } from '@/lib/lingua';

/** La lettura si fa una volta per avvio, anche se il componente si monta di nuovo (StrictMode). */
let giaLetta = false;

/**
 * La lingua scelta su un altro dispositivo, dalla CloudStorage di Telegram (`lib/lingua.ts`).
 * È un hook montato da `AppShell` e non una riga di `lib/i18n.ts` per una ragione sola: la
 * CloudStorage risponde solo DOPO l'init dell'SDK (`initTelegram`, `main.tsx`), e `AppShell` si
 * disegna dopo. Chiamata all'init di i18n, `cloudStorage.isSupported()` era falso e la lingua
 * non arrivava mai dagli altri dispositivi (rilievo di tma-orc su #541).
 */
export function useLinguaDalCloud(): void {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (giaLetta) return;
    giaLetta = true;
    idrataLinguaDalCloud((lingua) => void i18n.changeLanguage(lingua));
  }, [i18n]);
}
